export default [
    { path: 'changelog', name: 'controller.changelog' , component: () => import('@/views/controller/changeLog/HomeChangeLog.vue'), meta: { title: 'Lista de Atualizações ' } },
    { path: 'changelog', name: 'changelog.home' , component: () => import('@/views/controller/changeLog/HomeChangeLog.vue'), meta: { title: 'Lista de Atualizações ' } },
]